// Inspired by
// https://blog.guya.net/2015/06/12/sharing-sessionstorage-between-tabs-for-secure-multi-tab-authentication/

(function() {
    // wkhtmltopdf has sessionStorage but no localStorage
    if (window.sessionStorage && !window.localStorage) {
        debug.log('sessionStorage but no localStorage');
        return;
    }

    if (!sessionStorage.length) {
        // Ask other tabs for session storage
        localStorage.setItem('getSessionStorage', Date.now());
    };
    window.addEventListener('storage', function(event) {
        //debug.log('storage event', event);
        if (event.key == 'getSessionStorage') {
            debug.log('send session storage');
            // Some tab asked for the sessionStorage -> send it
            localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
            localStorage.removeItem('sessionStorage');
        } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
            debug.log('got session storage');
            // sessionStorage is empty -> fill it
            var data = JSON.parse(event.newValue);
            for (key in data) {
                sessionStorage.setItem(key, data[key]);
            }
        } else if (event.key == 'relogin') {
            // by setting localStorage.relogin, a tab can "tell" other tabs to remove session and show the login screen
            debug.log('relogin from other tab');
            app.removeSession();
            app.login();
        } else if (event.key == 'completeLogin') {
            // by setting localStorage.completeLogin, a tab can "tell" other tabs that we're logged in
            debug.log('complete login from other tab', event.newValue);
            app.completeLogin(JSON.parse(event.newValue));
            Backbone.history.loadUrl();
        } else if (event.key == 'impersonate') {
            debug.log('impersonate from other tab');
            app.setupImpersonation(JSON.parse(event.newValue));
        } else if (event.key == 'endImpersonation') {
            debug.log('end impersonation from other tab', event.newValue);
            app.endImpersonation();
        } else if (event.key == 'changeActiveGroups') {
            debug.log('change active groups from other tab');
            Core.client.me.set(JSON.parse(event.newValue));
            app.reloadMasterData(true);
        }
    });
})();
